export const AUTH_MODE_BASIC = "BASIC"
export const AUTH_MODE_OTP_EMAIL = "OTP-EMAIL"
export const AUTH_MODE_OTP_EMAIL_EXT = "OTP-EMAIL-EXTERNAL"
export const AUTH_MODE_OTP_SMS = "OTP-SMS"
export const AUTH_MODE_TOKEN = "TOKEN"
export const AUTH_MODE_PUBLIC = "PUBLIC"